export default __webpack_public_path__ + "static/media/Logo.e9065eaf.svg";